<template>
  <div class="factory">
    <Head></Head>
    <factoryPc v-if="!isPhone"></factoryPc>
    <factoryMobile v-if="isPhone"></factoryMobile>
    <Foot></Foot>
  </div>
</template>

<script>
import Head from "@/components/header-index.vue";
import Foot from "@/components/footer-index.vue";
import factoryPc from "./idPc.vue";
import factoryMobile from "./idMobile.vue";
export default {
  name: "factory",
  components: {
    Head,
    Foot,
    factoryPc,
    factoryMobile
  },
  data() {
    return {
      isPhone: false
    };
  },
  created() {
    // 判断是否手机
    this.getIsPhone();
    // 设置标题
    this.setTitle();
  },
  methods: {
    getIsPhone() {
      var userAgentInfo = navigator.userAgent;
      var Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
      ];
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          this.isPhone = true;
        }
      }
    },
    setTitle() {
      document.title = "上汽大众媒体中心";
    }
  }
};
</script>

<style>
</style>


